// extracted by mini-css-extract-plugin
export default {"button":"uo-z","reviewSort":"vo-z"};